import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import React from 'react';
import store from '../store';
import Support from '../components/support/support';
import { CurrencyProvider } from '../components/currency';

const support = document.getElementById('support');
if (support) {
    createRoot(support).render(
        <Provider store={store}>
            <CurrencyProvider>
                <Support />
            </CurrencyProvider>
        </Provider>
    );
}
